<script setup lang="ts">
import type { ListPaymentOptionsCreditPackage, ListPaymentOptionsSubscriptionDto } from '@swipe4work/api-client-fetch'
import CostPerMatchCard from './components/CostPerMatchCard.vue'
import SubscriptionsCard from './components/SubscriptionsCard.vue'

definePage({
  path: 'pakket',
  name: '/onboarding/subscription',
  meta: {
    layout: 'false',
    allowedRoles: [ 'CustomerOnboarding' ],
  },
})

const onboardingStore = useOnboardingStore()
const { companyModel, creditPackage, creditPackages, jobSlotOptions, subscription, subscriptions } = storeToRefs(onboardingStore)

function prevPage() {
  onboardingStore.goToPage(1)
}

if (companyModel.value === undefined) {
  onboardingStore.goToPage(1)
}

function selectCreditPackage(cp: ListPaymentOptionsCreditPackage) {
  creditPackage.value = cp
  subscription.value = undefined
  onboardingStore.goToPage(3)
}

function selectSubscription(sub: ListPaymentOptionsSubscriptionDto) {
  subscription.value = sub
  creditPackage.value = undefined
  onboardingStore.goToPage(3)
}

const { isLargeScreen } = useResponsive()
</script>

<template>
  <Card>
    <template #title>
      <h5>
        {{ $t("onboarding.subscription.description") }}
      </h5>
    </template>
    <template #content>
      <div class="min-h-[30rem]">
        <div flex="~ col xl:row" justify="center" space-x="6">
          <template v-if="isLargeScreen">
            <CostPerMatchCard :credit-packages="creditPackages" @next="selectCreditPackage" />
            <SubscriptionsCard :job-slot-options="jobSlotOptions" :subscriptions="subscriptions" @next="selectSubscription" />
          </template>
          <template v-else>
            <SubscriptionsCard :job-slot-options="jobSlotOptions" :subscriptions="subscriptions" @next="selectSubscription" />
            <CostPerMatchCard :credit-packages="creditPackages" @next="selectCreditPackage" />
          </template>
        </div>
        <div mt="8" mx="auto" text="center" max-w="sm xl:2xl">
          {{ $t("onboarding.subscription.pricingFooter") }}
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-between">
        <Button icon="bi bi-arrow-left" outlined rounded severity="secondary" @click="prevPage()" />
      </div>
    </template>
  </Card>
</template>
